import React from "react"

import Paper from "@mui/material/Paper"
import Popover from "@mui/material/Popover"
import Button from "@mui/material/Button"
import DeleteIcon from "@mui/icons-material/Delete"
import EditIcon from "@mui/icons-material/Edit"
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import { IconButton, Stack } from "@mui/material"
import { useSelector } from "react-redux/es/exports"
import { RootState } from "../../../../../app/store"
import { keycloakInstance } from "../../../../../shared/libs/keycloack/config"

export const SelectedCellsPopup = ({
  anchorEl,
  setAnchorEl,
  open,
  setOpen,
}: any) => {
  const handleClose = () => {
    setAnchorEl(null)
  }

  const openPopup = Boolean(anchorEl)
  const id = openPopup ? "simple-popover" : undefined

  const timeSlot = useSelector((state: RootState) => state.selectedTimeSlot)

  return (
    <>
      <Popover
        elevation={0}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        id={id}
        open={openPopup}
        anchorEl={anchorEl}
      >
        <Stack
          sx={{
            border: "1px solid rgba(27, 156, 24, 1)",
            p: 1,
            borderRadius: "4px",
          }}
          direction={"row"}
          spacing={"5px"}
        >
          <Button
            disabled
            size="small"
            sx={{ fontWeight: "bold" }}
            variant="contained"
          >
            Назначить собеседование
          </Button>
          <IconButton
            onClick={() => {
              setOpen({
                ...open,
                openCRUDTimeSlots: { open: true, type: "edit" },
              })
              setAnchorEl(null)
            }}
            sx={{
              border: "1px solid rgba(27, 156, 24, 1)",
              borderRadius: "4px",
            }}
          >
            <EditIcon sx={{ color: "primary.main" }} />
          </IconButton>
          
          <IconButton
            onClick={() => {
              setOpen({
                ...open,
                openCRUDTimeSlots: { open: true, type: "delete" },
              })
              setAnchorEl(null)
            }}
            sx={{
              border: "1px solid rgba(251, 55, 55, 1)",
              borderRadius: "4px",
            }}
          >
            <DeleteIcon sx={{ color: "rgba(251, 55, 55, 1)" }} color="error" />
          </IconButton>
          <IconButton
            onClick={() => {
              setOpen({
                ...open,
                openCRUDTimeSlots: { open: true, type: "info" },
              })
              setAnchorEl(null)
            }}
            sx={{
              border: "1px solid #0288d1",
              borderRadius: "4px",
            }}
          >
            <RecentActorsIcon color="info" />
          </IconButton>
        </Stack>
      </Popover>
    </>
  )
}
